<template>
  <div class="review">
    <a-tabs v-model:activeKey="activeKey" @change="tabChange">
      <a-tab-pane v-for="item in tabList" :key="item.value" :tab="item.name">
        <div class="query-item">
          <div class="search-l">
            <div>
              申请主体
              <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
            </div>
            <div class="ml30">
              车牌号
              <a-input class="inp ml24" placeholder="请输入" v-model:value="query.carNum"></a-input>
            </div>
            <div class="ml30" v-if="activeKey > 0">
              状态
              <a-select class="inp ml24" v-if="activeKey == 1" v-model:value="check_status" placeholder="请选择">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="0">待材料审核</a-select-option>
                <a-select-option value="1">待专家组审查</a-select-option>
                <a-select-option value="2">待联席工作小组审核</a-select-option>
                <a-select-option value="3">材料待修改</a-select-option>
              </a-select>

              <a-select class="inp ml24" v-if="activeKey == 2" v-model:value="check_status" placeholder="请选择">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="0">审核不通过</a-select-option>
                <a-select-option value="1">审核通过</a-select-option>
              </a-select>
            </div>
            <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
            <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
            <div></div>
          </div>
        </div>
        <a-table :columns="activeKey == 0 ? columns : columns2" :row-key="(record) => record.id"
          :data-source="dataSource" class="mt23" size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
          v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'createTime'">
              {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template v-if="column.key === 'category'">
              {{
      getSingleTypeValue(
        appStore.SysDictVOList,
        "testType" + "category" + record.category
      )
    }}
            </template>
            <template v-if="column.key === 'carType'">
              {{
      getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + record.carType)
    }}
            </template>
            <template v-if="column.key === 'status'">
              <div>
                {{ getStatusTxt(record) }}
              </div>
            </template>
            <template v-else-if="column.key === 'action'">
              <span>
                <a class="mr10" @click="detail(record)">查看详情</a>
                <span v-if="activeKey === 0">
                  <a v-if="record.status === 0 && store.hasPermi('qualification:review:materials')" @click="audit(record)">开始审核</a>
                </span>
<!--                <span v-if="activeKey === 1">-->
<!--                  <a v-if="record.status === 1 && !record.checkFlowNode && store.roles.includes('organization')" @click="audit(record)">材料审核</a>-->
<!--                  <a v-if="record.status === 1 && record.checkFlowNode === 1 && store.roles.includes('experts')" @click="audit(record)">专家组审核</a>-->
<!--                  <a v-if="record.status === 1 && record.checkFlowNode === 2 && store.roles.includes('jointGroup')" @click="audit(record)">联席小组审核</a>-->
<!--                </span>-->
                <span v-if="activeKey === 1">
                  <a v-if="record.status === 1 && !record.checkFlowNode && store.hasPermi('qualification:review:materials')" @click="audit(record)">材料审核</a>
                  <a v-if="record.status === 1 && record.checkFlowNode === 1 && store.hasPermi('qualification:review:meeting')" @click="audit(record)">专家组审核</a>
                  <a v-if="record.status === 1 && record.checkFlowNode === 2 && store.hasPermi('qualification:review:final')" @click="audit(record)">联席小组审核</a>
                </span>
              </span>
            </template>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <reviewModal :modalTitle="'专家审核'" :modalWidth="'702px'" :isDetailStatus="true" ref="modalRef"
      @saveEvent="saveEvent1">
      <div class="mt32 mb85">
        <div class="radio_class mb26">
          <span>审核：</span>
          <a-radio-group class="ml26" v-model:value="modalObj.checkStatus">
            <a-radio :value="1">审核通过</a-radio>
            <a-radio :value="0">审核不通过</a-radio>
          </a-radio-group>
        </div>

        <div class="modal_item">
          <div class="file_text">
            <div class="fil_it">
              <span class="file_tit">专家组会议纪要：</span>
              <span class="file_ic">
                <FileTextOutlined class="file_icon mr5" />专家组会议纪要.pdf
              </span>
              <img class="pl30" :src="group1" alt="" />

              <uploadButton class="pl60" :updateTitle="'点击上传'" ref="uploadRef"
                accept=".doc,.docx,.pdf,.jpg,.png,.xls,.xlsx" :maxCount="1" pathName="" @uploadFinished="uploadFinished"
                :info="fileList[0]" :title="'专家组会议纪要'">
              </uploadButton>
            </div>
          </div>
          <div class="file_text">
            <div class="fil_it">
              <span style="padding-left: 14px" class="file_tit">专家组签到表：</span>
              <span class="file_ic">
                <FileTextOutlined class="file_icon mr5" />专家组签到表.pdf
              </span>
              <img class="pl43" :src="group2" alt="" />

              <uploadButton class="pl64" :updateTitle="'点击上传'" ref="uploadRef"
                accept=".doc,.docx,.pdf,.jpg,.png,.xls,.xlsx" :maxCount="1" pathName="" @uploadFinished="uploadFinished"
                :info="fileList[1]" :title="'专家组签到表'">
              </uploadButton>
            </div>
          </div>
          <div class="file_text">
            <div class="fil_it">
              <span class="file_tit">专家组汇总意见：</span>
              <span class="file_ic">
                <FileTextOutlined class="file_icon mr5" />专家组汇总意见.pdf
              </span>
              <img class="pl30" :src="group3" alt="" />

              <uploadButton class="pl60" :updateTitle="'点击上传'" ref="uploadRef"
                accept=".doc,.docx,.pdf,.jpg,.png,.xls,.xlsx" :maxCount="1" pathName="" @uploadFinished="uploadFinished"
                :info="fileList[2]" :title="'专家组汇总意见'">
              </uploadButton>
            </div>
          </div>
          <div class="file_text">
            <div class="fil_it">
              <span class="file_tit">专家组个人意见：</span>
              <span class="file_ic">
                <FileTextOutlined class="file_icon mr5" />专家组个人意见.pdf
              </span>
              <img class="pl30" :src="group4" alt="" />

              <uploadButton class="pl60" :updateTitle="'点击上传'" ref="uploadRef"
                accept=".doc,.docx,.pdf,.jpg,.png,.xls,.xlsx" :maxCount="1" pathName="" @uploadFinished="uploadFinished"
                :info="fileList[3]" :title="'专家组个人意见'">
              </uploadButton>
            </div>
          </div>
        </div>

        <div class="radio_class mt22 area_class">
          审核意见：
          <a-textarea class="area_width" v-model:value="modalObj.checkMsg" placeholder="请输入（审批通过时此处非必填" :rows="4" />
        </div>
      </div>
    </reviewModal>

    <reviewModal :modalTitle="'联席工作小组审核'" :modalWidth="'702px'" :isDetailStatus="true" ref="modalRefJoint"
      @saveEvent="saveEvent2">
      <div class="mt32 mb85">
        <div class="radio_class mb26">
          <span>审核：</span>
          <a-radio-group class="ml26" v-model:value="modalObj.checkStatus">
            <a-radio :value="1">审核通过</a-radio>
            <a-radio :value="0">审核不通过</a-radio>
          </a-radio-group>
        </div>

        <div class="modal_item">
          <div class="file_text">
            <div class="fil_it" style="padding-left: 7px">
              <span class="file_tit">联席工作小组会议纪要：</span>
              <span class="file_ic">
                <FileTextOutlined class="file_icon mr5" />联席工作小组会议纪要.pdf
              </span>
              <img class="pl15" :src="group5" alt="" />

              <uploadButton class="pl60" :updateTitle="'点击上传'" ref="uploadRef"
                accept=".doc,.docx,.pdf,.jpg,.png,.xls,.xlsx" :maxCount="1" pathName="" @uploadFinished="uploadFinished"
                :info="fileList2[0]" :title="'联席工作小组会议纪要'">
              </uploadButton>
            </div>
          </div>
          <div class="file_text">
            <div class="fil_it">
              <span class="file_tit">道路测试通知书：</span>
              <span class="file_ic">
                <FileTextOutlined class="file_icon mr5" />道路测试通知书.pdf
              </span>
              <img class="pl55" :src="group6" alt="" />

              <uploadButton class="pl64" :updateTitle="'点击上传'" ref="uploadRef"
                accept=".doc,.docx,.pdf,.jpg,.png,.xls,.xlsx" :maxCount="1" pathName="" @uploadFinished="uploadFinished"
                :info="fileList2[1]" :title="'道路测试通知书'">
              </uploadButton>
            </div>
          </div>
        </div>

        <div class="radio_class mt22 area_class">
          审核意见：
          <a-textarea class="area_width" v-model:value="modalObj.checkMsg" placeholder="请输入（审批通过时此处非必填" :rows="4" />
        </div>
      </div>
    </reviewModal>
  </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, nextTick, onActivated } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import useAppStore from "@/store/modules/app";
import reviewModal from "@/components/modal/index.vue";
import uploadButton from "@/components/uploadButton/index.vue";
import {
  qualificationList,
  startCheckMaterial,
  checkQualificationInfo,
} from "@/api/qualification/index";
import { getSingleTypeValue } from "@/utils/matchDic.js";
import { message } from "ant-design-vue";
import useUserStore from "@/store/modules/user";

const router = useRouter();
const appStore = useAppStore();
const store = useUserStore();

const activeKey = ref(0);
const radioValue = ref(0);
const textAreaValue = ref("");
const textAreaValueJoint = ref("");
const radioValueJoint = ref(0);
const columns = [
  {
    title: "编号",
    dataIndex: "id",
    key: "id",
    // width: 100,
    fixed: "left",
  },
  {
    title: "申请主体",
    dataIndex: "deptName",
    key: "deptName",
    // width: 150,
  },
  {
    title: "测试类型",
    key: "category",
    dataIndex: "category",
  },
  {
    title: "车架号",
    key: "carFrameNum",
    dataIndex: "carFrameNum",
  },
  {
    title: "测试车辆类型",
    key: "carType",
    dataIndex: "carType",
  },
  {
    title: "申请时间",
    key: "createTime",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 240,
  },
];

const columns2 = [
  {
    title: "编号",
    dataIndex: "id",
    key: "id",
    // width: 100,
    fixed: "left",
  },
  {
    title: "申请主体",
    dataIndex: "deptName",
    key: "deptName",
    // width: 150,
  },
  {
    title: "测试类型",
    key: "category",
    dataIndex: "category",
  },
  {
    title: "车架号",
    key: "carFrameNum",
    dataIndex: "carFrameNum",
  },
  {
    title: "测试车辆类型",
    key: "carType",
    dataIndex: "carType",
  },
  {
    title: "申请时间",
    key: "createTime",
    dataIndex: "createTime",
  },
  {
    title: "状态",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 240,
  },
];

const tabList = ref([
  { value: 0, name: "待审批" },
  { value: 1, name: "审批中" },
  { value: 2, name: "已审批" },
]);

let query = reactive({
  deptName: "",
  carNum: "",
  status: "0",
});

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.deptName = "";
  query.carNum = "";
  query.status = "0";
  check_status.value = "";
  pagination.current = 1;
  getData();
};

const tabChange = (val) => {
  check_status.value = "";
  getData();
};

let dataSource = ref([]);

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const check_status = ref();
const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, status: activeKey.value },
  };
  if (activeKey.value == 1) {
    data.conditionMap.check_flow_node = check_status.value;
  }
  if (activeKey.value == 2) {
    data.conditionMap.checkResultJointGroup = check_status.value;
  }

  qualificationList(data).then((res) => {
    //    res.data.records.map((item, index) => {
    //     item.ranking = index + 1;
    //   });
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

const modalRef = ref();
const modalRefJoint = ref();
const modalObj = ref();
const audit = (record) => {
  console.log(record);
  modalObj.value = record;
  if (record.status === 0) {
    startCheckMaterial({ qualificationId: record.id }).then((res) => {
      if (res.code === 200) {
        router.push({
          path: "/qualificationManage/examineDetail",
          query: {
            type: "edit",
            id: record.id,
          },
        });
      }
    });
  } else if (record.status === 1) {
    //checkFlowNode null 待材料审核
    if (!record.checkFlowNode) {
      router.push({
        path: "/qualificationManage/examineDetail",
        query: {
          type: "edit",
          id: record.id,
        },
      });
    }

    if (record.checkFlowNode == 1) {
      // 重置专家组审核文件列表
      fileList.value.forEach(item => {
        item.uploadFile = '';
      });
      modalRef.value.showModal();
    }
    if (record.checkFlowNode == 2) {
      // 重置联席小组审核文件列表
      fileList2.value.forEach(item => {
        item.uploadFile = '';
      });
      modalRefJoint.value.showModal();
    }
  } else if (record.status === 2) {
    // nextTick(() => {
    //     console.log(modalRefJoint.value);
    //     modalRefJoint.value.showModal()
    // })
  }
};

const fileList = ref([
  {
    id: 1,
    category: 2,
    name: "这是一个会议文件",
    uploadFile: "",
  },
  {
    id: 2,
    category: 2,
    name: "这是一个会议文件",
    uploadFile: "",
  },
  {
    id: 3,
    category: 2,
    name: "这是一个会议文件",
    uploadFile: "",
  },
  {
    id: 4,
    category: 2,
    name: "这是一个会议文件",
    uploadFile: "",
  },
]);

const fileList2 = ref([
  {
    id: 1,
    category: 1,
    name: "这是一个会议文件",
    uploadFile: "",
  },
  {
    id: 2,
    category: 2,
    name: "这是一个结果文件",
    uploadFile: "",
  },
]);

const qualicationCheckFiles = ref();

const group1 = ref(require("../../assets/images/group.png"));
const group2 = ref(require("../../assets/images/group.png"));
const group3 = ref(require("../../assets/images/group.png"));
const group4 = ref(require("../../assets/images/group.png"));
const group5 = ref(require("../../assets/images/group.png"));
const group6 = ref(require("../../assets/images/group.png"));
// uploadRef.value.clearFileList()
const uploadFinished = (url, row, title) => {
  console.log(url, "111111111");
  console.log(row, "111111111");
  console.log(title);
  if (title === '联席工作小组会议纪要' || title === '道路测试通知书') {
    fileList2.value.map((item) => {
      if (row.id == item.id) {
        item.uploadFile = url;
      }
    });
  } else {
    fileList.value.map((item) => {
      if (row.id == item.id) {
        item.uploadFile = url;
      }
    });
  }

  console.log(fileList.value);
  switch (title) {
    case "专家组会议纪要":
      group1.value = require("../../assets/images/light_group.png");
      break;
    case "专家组签到表":
      group2.value = require("../../assets/images/light_group.png");
      break;
    case "专家组汇总意见":
      group3.value = require("../../assets/images/light_group.png");
      break;
    case "专家组个人意见":
      group4.value = require("../../assets/images/light_group.png");
      break;
    case "联席工作小组会议纪要":
      group5.value = require("../../assets/images/light_group.png");
      break;
    case "道路测试通知书":
      group6.value = require("../../assets/images/light_group.png");
      break;
    default:
      "";
  }
};

const uploadFinished2 = (url, row) => {
  console.log(data, "111111111");
  fileList2.value.map((item) => {
    if (row.id == item.id) {
      item.uploadFile = url;
    }
  });
};

//审核
function check(record, type) {
  console.log(record)
  checkQualificationInfo(record).then((res) => {
    if (res.code == 200) {
      getData();
      message.success("成功");
      if (type) {
        modalRef.value.hideModal();
      } else {
        modalRefJoint.value.hideModal();
      }
    }
  })
}

//专家组审核
function saveEvent1() {
  console.log(fileList.value);
  let obj = {
    checkMsg: modalObj.value.checkMsg,
    checkStatus: modalObj.value.checkStatus,
    checkType: 1,
    qualicationCheckFiles: fileList.value,
    qualificationId: modalObj.value.id,
    carId: modalObj.value.carId,
  };
  console.log("专家组审核数据", obj);
  check(obj, 1);
}

//联席小组审核
function saveEvent2() {
  let obj = {
    checkMsg: modalObj.value.checkMsg,
    checkStatus: modalObj.value.checkStatus,
    checkType: 2,
    qualicationCheckFiles: fileList2.value,
    qualificationId: modalObj.value.id,
    carId: modalObj.value.carId,
  };
  console.log("联席小组审核数据", obj);
  check(obj);
}

const detail = (record) => {
  console.log(record);
  router.push({
    path: "/qualificationManage/examineDetail",
    query: {
      id: record.id,
      type: "detail",
    },
  });
};

const getStatusTxt = (val) => {
  let str = "";
  if (activeKey.value == 1) {
    //审核中

    // switch (val.checkFlowNode) {
    //   case 1:
    //     str = "待专家组审核";
    //     break;
    //   case 2:
    //     str = "待联席小组审核";
    //     break;
    //   default:
    //     str = "待第三方机构审核";
    //     break;
    // }
    switch (val.checkFlowNode) {
      case 0:
        str = "材料审核";
        break;
      case 1:
        str = "专家组审核";
        break;
      case 2:
        str = "联席工作小组审核";
        break;
      case 3:
        str = "材料审核不通过";
        break;
      case 4:
        str = "资质失效";
        break;
      default:
        str = "审核中";
        break;
    }
  } else {
    //已审批
    switch (val.checkResultJointGroup) {
      case 0:
        str = "审核不通过";
        break;
      case 1:
        str = "审核通过";
        break;
      default:
        str = "";
        break;
    }
  }
  return str;
};

onActivated(() => {
  getData();
});
</script>
<style lang="less" scoped>
.review {
  padding: 13px 20px 20px 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

.modal_item {
  padding: 0 26px 106px 23px;
  background: #f6f8fa;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

  .file_text {
    padding-top: 19px;
    border-bottom: 1px solid #d4e0f0;

    .fil_it {
      display: flex;
      align-items: center;
      padding-left: 49px;
      padding-bottom: 19px;

      .file_tit {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #6c7683;
      }

      .file_ic {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1d2129;
      }
    }

    .file_icon {
      color: rgba(24, 111, 242, 1);
    }
  }
}

.mr10 {
  margin-left: 10px;
}

a {
  color: #1e8ef2;
}

.radio_class {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgba(29, 33, 41, 1);
}

.area_class {
  // display: flex;
}

.area_width {
  // width: 420px;
  // margin-left: 26px;
  margin-top: 22px;
}

.mt22 {
  margin-top: 22px;
}

.mt32 {
  margin-top: 32px;
}

.mb85 {
  margin-bottom: 85px;
}

.mb26 {
  margin-bottom: 26px;
}

.ml26 {
  margin-left: 26px;
}

.pl30 {
  padding-left: 30px;
}

.pl43 {
  padding-left: 43px;
}

.pl15 {
  padding-left: 15px;
}

.pl55 {
  padding-left: 55px;
}

.pl60 {
  padding-left: 60px;
}

.pl64 {
  padding-left: 64px;
}

/deep/.ant-tabs .ant-tabs-tab {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  margin: 0 0 0 70px;
  color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
  height: 3px;
  // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
  width: 130px;
}
</style>
